(function() {
  // Helper to get item with expiry
  function getWithExpiry(key) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;
    try {
      const item = JSON.parse(itemStr);
      const now = new Date();
      if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        return null;
      }
      return item.value;
    } catch (e) {
      return null;
    }
  }

  // Helper to set item with expiry
  function setWithExpiry(key, value, ttl) {
    const now = new Date();
    const item = {
      value: value,
      expiry: now.getTime() + ttl,
    };
    try {
        localStorage.setItem(key, JSON.stringify(item));
    } catch(e) {}
  }

  // Check URL params for bypass
  try {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('skip_country_check') === 'true') {
      const isRemembered = urlParams.get('remember_selection') === 'true';
      const now = new Date();
      let ttl;
       if (isRemembered) {
         ttl = 14 * 24 * 60 * 60 * 1000; // 14 days
      } else {
         const midnight = new Date(now);
         midnight.setHours(24, 0, 0, 0);
         ttl = midnight.getTime() - now.getTime(); // Until midnight
      }
      
      // Save 'UK' as default preference when skipping check, ensuring we don't redirect again
      setWithExpiry('unze-selected-country', 'UK', ttl);
      return;
    }
  } catch (e) {
    console.error('Error checking skip_country_check param', e);
  }

  // 1. Check Domain. Only run on unze.co.uk (Main Domain)
  const validDomains = ['unze.co.uk', 'www.unze.co.uk'];
  const currentHost = (window.location.hostname || "").toLowerCase();
  
  if (!validDomains.includes(currentHost)) {
    return;
  }

  // 2. Check if user already made a selection
  const selectedCountry = getWithExpiry('unze-selected-country');
  if (selectedCountry) {
    return; 
  }

  // 3. Check Timezone
  let zone = "";
  try {
    zone = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  } catch (_) {}

  // "if the timezone is not uk" -> Europe/London
  // we check if it is NOT Europe/London
  const isUKTimezone = zone === 'Europe/London';
  
  if (!isUKTimezone) {
    const isSelectCountryPage = window.location.pathname.includes('/pages/select-country');
    if (!isSelectCountryPage) {
      console.log('Non-UK timezone detected on UK site. Redirecting to selection.');
      window.location.replace('/pages/select-country');
    }
  }

})();
